<template>
  <v-expansion-panel-header
    style="min-height: min-content"
    @click="$emit('click')"
  >
    <slot />
  </v-expansion-panel-header>
</template>

<script>
export default {
  name: 'DisplayExpansionPanelHeader',
};
</script>
